import { MoonIcon, SunIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

import { cn } from "@/lib/utils";
import { useThemeStore } from "@/store";

interface ChangeThemeProps {
  /**
   * `icon`     — yalang'och ikonka tugmasi (sarlavha, auth qobig'i).
   * `dropdown` — mavjud ochiluvchi menyu ichidagi qator.
   * `tab`      — ramkali ichki boshqaruv (futer, mobil sheet).
   */
  type?: "icon" | "dropdown" | "tab";
  className?: string;
}

/**
 * Yorug'/qorong'i almashtirgichi. Endi menyu ham, "system" bandi ham yo'q —
 * mavzu bitta bosishda ag'dariladi; bu ilovaga shundan ortig'i kerak emas.
 */
export function ChangeTheme({ type = "icon", className }: Readonly<ChangeThemeProps>) {
  const { t } = useTranslation();
  const theme = useThemeStore(state => state.theme);
  const toggleTheme = useThemeStore(state => state.toggleTheme);

  const isDark = theme === "dark";
  // Yorliq qayerda turganingizni emas, bosgandan keyin qayerga o'tishingizni aytadi.
  const label = isDark ? t("COMMON.LIGHT") : t("COMMON.DARK");
  const Icon = isDark ? SunIcon : MoonIcon;

  if (type === "dropdown") {
    return (
      <DropdownMenuItem
        onSelect={event => {
          // Menyu ochiq qoladi: mavzu almashuvini shu yerda ko'rib turish ma'qul.
          event.preventDefault();
          toggleTheme();
        }}
        className={cn("cursor-pointer gap-2", className)}
      >
        <Icon className="size-4" />
        <span className="flex-1">{label}</span>
      </DropdownMenuItem>
    );
  }

  if (type === "tab") {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        title={t("COMMON.CHANGE_THEME")}
        aria-label={t("COMMON.CHANGE_THEME")}
        className={cn(
          "border-border bg-muted text-muted-foreground hover:text-foreground inline-flex h-9 items-center gap-2 rounded-lg border px-3 text-sm font-medium transition-colors",
          className,
        )}
      >
        <Icon className="size-4" />
        <span>{label}</span>
      </button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={toggleTheme}
      title={t("COMMON.CHANGE_THEME")}
      aria-label={t("COMMON.CHANGE_THEME")}
      className={className}
    >
      <Icon className="size-4" />
    </Button>
  );
}
